import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { L as LOGIN_FAILED, e as LOGIN_SUCCESS, S as SET_IS_LOADING, f as LOGOUT } from './types-0b7e03a3.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var initialState = {
  user: {},
  message: "",
  isLoading: true,
  errors: [],
  is2FAEnabled: true,
  allowSkip2FA: false
};
function loginReducer () {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOGOUT:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: {},
        message: "Logged Out User",
        errors: []
      });

    case SET_IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.payload,
        message: action.payload.message
      });

    case LOGIN_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.payload.user,
        is2FAEnabled: action.payload.is2FAEnabled,
        allowSkip2FA: action.payload.allowSkip2FA,
        message: action.payload.message
      });

    case LOGIN_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        message: action.payload.message,
        is2FAEnabled: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.is2FAEnabled,
        allowSkip2FA: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.allowSkip2FA,
        errors: action.payload.errors
      });

    default:
      return state;
  }
}

export { loginReducer as default };
